import PizzaBuilderDesktopExpanded from './PizzaBuilderDesktopExpanded';

export default PizzaBuilderDesktopExpanded;
